export const getters = {
  newMessagesCount(state) {
    return state.newChatMessages.length
  },
}
